import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, message } from "antd";
import { GrantsTable } from "../../styles";
import RemovePopup from "../../../../../../CommonComponents/CharitySearch/Component/RemovePopup/RemovePopup";
import RemoveGeminiPopup from "../../../../../../CommonComponents/CharitySearch/Component/RemoveGemini/RemoveGeminiPopup";
import { tableConfig } from "../../../../../../CommonComponents/CharitySearch/config";
import { geminiTableConfig } from "../../../../../../CommonComponents/CharitySearch/geminiConfig";
import MultipleCharityPopup from "../../../../../../CommonComponents/CharitySearch/Component/MultipleCharity/MultipleCharity";
import RenderCard from "../../../RecommendGrant/Component/RenderCard/RenderCard";
import { LoadMoreButton, EndResult } from "./style";
import {
  grantUpdateLoadMoreCounter,
  grantUpdatefrom,
  grantEinData,
  grantGeminiEinData,
  cancelSaveCharity,
  grantPostSavedCharity,
} from "../../actions";
import { getPrimaryAccount } from "../../../../../../utils/sessionUtil";
import { charityEligibilityChecker } from "../../../../../../utils/commonUtil";
import { handleGuideStarRedirect } from "../../../../../../CommonComponents/CharitySearch/utils";
import DrupalPopup from "../../../RecommendGrant/Component/Popup/DrupalPopup";
import PropTypes from 'prop-types';
import { searchTableState } from "./selectors";

export class GrantSearchTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: 2,
      error: false,
      counter: 1,
      visiblePopup: false,
      visibleGeminiPopup: false,
      showSavedCharityData: "",
      savedGeminiData: "",
      fetchGeminiEinSuccessData: "",
      ein: "",
      legalName: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      state: "",
      city: "",
      country: "",
      zip: "",
      charityContactFirstName: "",
      charityContactLastName: "",
      email: "",
      phoneNumber: "",
      selectedCharity: {},
      multipleCharities: [],
      partialEligibility: false,
      eligible: true,
      selectedCharityData: {},
    };
    this.multipleCharitySaveHandler = this.multipleCharitySaveHandler.bind(
      this
    );
  }

  savedCharityModal = (data) => {
    this.setState({
      visiblePopup: !this.state.visiblePopup,
      showSavedCharityData: data,
      showPopup: !this.state.showPopup,
    });
  };

  savedGeminiModal = (data) => {
    this.setState({
      visibleGeminiPopup: !this.state.visibleGeminiPopup,
      savedGeminiData: data,
    });
  };

  handleMapping = (data) => {
    const cloneState = { ...data };
    const keyArr = Object.keys(cloneState);
    let newObj = {};
    keyArr.forEach((item, i) => {
      if (data[item]) {
        newObj[item] = data[item];
      } else {
        if (data[item] !== undefined) newObj[item] = "";
      }
    });
    return newObj;
  };

  removeSavedCharityModal = (data) => {
    const obj = this.handleMapping(data);
    this.setState({ selectedCharityData: obj });
    const eligibility = charityEligibilityChecker({
      pub78: obj.properties.pub78_verified,
      bmfStatus: obj.properties.bmf_status,
      subSection: obj.subsection_code,
      foundationCode: obj.foundation_code,
    });
    if (eligibility.mandatory && eligibility.partial) {
      this.props.saveCharity(obj, this.multipleCharitySaveHandler);
    } else if (eligibility.mandatory && !eligibility.partial) {
      this.setState({ partialEligibility: true });
    } else {
      this.setState({ eligible: false });
    }
  };

  saveInEligibleCharities = () => {
    const { selectedCharityData } = this.state;
    this.setState({ partialEligibility: false, eligible: true });
    let recordToSave = {
      ein: selectedCharityData.ein,
      legalName: selectedCharityData.organization_name,
      addressLine1: selectedCharityData.address_line_1,
      addressLine2: selectedCharityData.address_line_2,
      addressLine3: "",
      state: selectedCharityData.state,
      city: selectedCharityData.city,
      country: "US",
      zip: selectedCharityData.zip,
      charityContactFirstName: selectedCharityData.contact_name,
      charityContactLastName: "",
      email: selectedCharityData.contact_email,
      phoneNumber: selectedCharityData.contact_phone,
    };
    this.props.postSavedCharity(
      {
        userId: getPrimaryAccount().userId,
        charityData: recordToSave,
      },
      (response) =>
        this.multipleCharitySaveHandler(response, selectedCharityData)
    );
  };

  multipleCharitySaveHandler = (savedRecord, reqRecord) => {
    if (savedRecord.isExisting) {
      if (savedRecord.granteeOrgs && savedRecord.granteeOrgs.length === 1) {
        // add charity directly and proceed
        this.saveSelectedCharity(savedRecord.granteeOrgs[0]);
      } else if (
        savedRecord.granteeOrgs &&
        savedRecord.granteeOrgs.length > 1
      ) {
        // show multiple charity popup
        // if user tries to save multiple with ein conflict, keep first cancel rest
        if (!Object.keys(this.state.selectedCharity).length) {
          this.setState({
            multipleCharities: savedRecord.granteeOrgs,
            selectedCharity: { ...reqRecord },
          });
        } else {
          this.props.cancelSaveCharity(reqRecord);
        }
      }
    }
  };

  saveSelectedCharity = (charity) => {
    this.props.addCharity(charity);
    this.setState({
      multipleCharities: [],
      selectedCharity: {},
    });
  };

  onCancelMultipleCharity = () => {
    this.props.cancelSaveCharity(this.state.selectedCharity);
    this.setState({
      multipleCharities: [],
      selectedCharity: {},
    });
  };

  removedGeminiModal = (data) => {
    this.props.saveGeminiCharity(data);
    this.setState({
      fetchGeminiEinSuccessData: data.ein,
    });
  };

  updateFromCounter = (data) => {
    this.setState(
      (prev) => {
        return { visible: prev.visible + data };
      },
      () => {
        this.props.updateLoadMoreCounter(data);
      }
    );
  };

  savedCharityHandler = () => {
    message.success("Your charity is saved");
    this.props.getSavedCharity(getPrimaryAccount().userId);
  };

  componentWillReceiveProps(nextprops) {
    if (
      nextprops.charitySaved &&
      nextprops.charitySaved !== this.props.charitySaved
    ) {
      this.savedCharityHandler();
    }

    if (
      this.props.updatedSearchData.length !== nextprops.updatedSearchData.length
    ) {
      let counter = nextprops.updatedCounterData;
      this.setState({ counter: counter });
    }
  }

  render() {
    const {
      columnData,
      updatedSearchData,
      pendingCharityHandler,
      updatedCounterData,
      showGeminiFilter,
      activityBlocked = "",
    } = this.props;
    const {
      counter,
      showSavedCharityData,
      visiblePopup,
      visibleGeminiPopup,
      removedCharityData,
      savedGeminiData,
      multipleCharities,
    } = this.state;
    const {
      savedCharityModal,
      removeSavedCharityModal,
      removedGeminiModal,
      savedGeminiModal,
    } = this;
    return (
      <div>
        <Row>
          {showGeminiFilter ? (
            <>
              <Row>
              </Row>
              <Col lg={24} md={24} xs={0}>
                <GrantsTable
                  className="main"
                  columns={geminiTableConfig(
                    pendingCharityHandler,
                    savedGeminiModal,
                    removedGeminiModal,
                    activityBlocked
                  )}
                  dataSource={columnData}
                  pagination={false}
                />
                <EndResult>
                  You have reached the end of search results.
                </EndResult>
              </Col>
              <Col lg={0} md={0} xs={24}>
                {columnData.map((data, index) => (
                  <RenderCard
                    key={index}
                    index={index}
                    data={data}
                    component="SearchGeminiCard"
                    pendingCharityHandler={pendingCharityHandler}
                    removedGeminiModal={removedGeminiModal}
                    savedGeminiModal={savedGeminiModal}
                    activityBlocked={activityBlocked}
                  />
                ))}
                <EndResult>
                  You have reached the end of search results.
                </EndResult>
              </Col>
            </>
          ) : (
            <>
              <Row>
              </Row>
              <Col lg={24} md={24} xs={0}>
                <GrantsTable
                  className="main"
                  columns={tableConfig(
                    pendingCharityHandler,
                    savedCharityModal,
                    removeSavedCharityModal,
                    activityBlocked,
                    handleGuideStarRedirect
                  )}
                  dataSource={updatedSearchData}
                  pagination={false}
                />

                {this.props.guidestarSearchCount === columnData.length ? (
                  <div></div>
                ) : (
                  <LoadMoreButton id="btnLoadmore1" onClick={() => this.props.updatefrom()}>
                    {" "}
                    Load more
                  </LoadMoreButton>
                )}
              </Col>
              <Col lg={0} md={0} xs={24}>
                {updatedSearchData.map((data, index) => (
                  <RenderCard
                    index={index}
                    data={data}
                    component="SearchCharityCard"
                    pendingCharityHandler={pendingCharityHandler}
                    removeSavedCharityModal={removeSavedCharityModal}
                    savedCharityModal={savedCharityModal}
                    activityBlocked={activityBlocked}
                    searchResultClickHandler={handleGuideStarRedirect}
                  />
                ))}
                {this.props.guidestarSearchCount === columnData.length ? (
                  <div></div>
                ) : (
                  <LoadMoreButton id="btnLoadmore2" onClick={() => this.props.updatefrom()}>
                    {" "}
                    Load more
                  </LoadMoreButton>
                )}
              </Col>
            </>
          )}
        </Row>
        {visiblePopup ? (
          <RemovePopup
            page={"Grants Dashboard"}
            showSavedCharityData={showSavedCharityData}
            removeCharity={this.props.removeSavedCharity}
            einData={this.props.einData}
            keyProperty={"Remove Charity Grants Dashboard"}
          />
        ) : (
          <div />
        )}

        {visibleGeminiPopup ? (
          <RemoveGeminiPopup
            page={"Grants Dashboard"}
            savedGeminiData={savedGeminiData}
            removeCharity={this.props.removeSavedCharity}
            geminiEinData={this.props.geminiEinData}
            keyProperty={"Remove Charity Grants Dashboard"}
          />
        ) : (
          <div />
        )}
        {multipleCharities.length ? (
          <MultipleCharityPopup
            show={!!multipleCharities.length}
            charities={multipleCharities}
            secondaryCta={this.onCancelMultipleCharity}
            primaryCta={this.saveSelectedCharity}
          />
        ) : (
          ""
        )}
        <DrupalPopup
          html={true}
          page={"Grants Overview"}
          show={!this.state.eligible}
          defaultPrimaryLabel={"Ok"}
          defaultSecondaryLabel={"Cancel"}
          defaultTitle={"Warning"}
          keyProperty={"Ineligible"}
          defaultDescription={
            "The charity you selected is not identified as a 501(c)(3) public charity by GuideStar. Vanguard Charitable will need to review the organization before issuing a grant. Click OK to continue with a grant, or CANCEL to select another charity"
          }
          primaryCta={this.saveInEligibleCharities}
          secondaryCta={() => this.setState({ eligible: true })}
          alertId="overview-ineligibility"
        />
        <DrupalPopup
          html={true}
          page={"Grants Overview"}
          show={this.state.partialEligibility}
          defaultPrimaryLabel={"Ok"}
          defaultSecondaryLabel={"Cancel"}
          defaultTitle={"Warning"}
          keyProperty={"Partial Eligible"}
          defaultDescription={
            "The charity you selected is identified as a 501(c)(3), 509(a)(3) supporting organization by GuideStar. You may experience grant processing delays since this type of organization requires additional research. Click OK to continue with a grant, or CANCEL to select another charity"
          }
          primaryCta={this.saveInEligibleCharities}
          secondaryCta={() => this.setState({ partialEligibility: false })}
          alertId="overview-partial-eligibility"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...searchTableState(state.toJS()),
});

const mapDispatchToProps = (dispatch) => ({
  updatefrom: () => dispatch(grantUpdatefrom()),
  updateLoadMoreCounter: (data) => dispatch(grantUpdateLoadMoreCounter(data)),
  einData: (data) => dispatch(grantEinData(data)),
  geminiEinData: (data) => dispatch(grantGeminiEinData(data)),
  cancelSaveCharity: (data) => dispatch(cancelSaveCharity(data)),
  postSavedCharity: (data, successFn) =>
    dispatch(grantPostSavedCharity(data, successFn)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GrantSearchTable);

GrantSearchTable.propTypes = {
  activityBlocked: PropTypes.string,
  addCharity: PropTypes.func,
  cancelSaveCharity: PropTypes.func,
  charitySaved: PropTypes.bool,
  columnData: PropTypes.array,
  einData: PropTypes.func,
  geminiEinData: PropTypes.func,
  getSavedCharity: PropTypes.func,
  guidestarSearchCount: PropTypes.number,
  pendingCharityHandler: PropTypes.func,
  removeSavedCharity: PropTypes.func,
  saveGeminiCharity: PropTypes.func,
  showGeminiFilter: PropTypes.bool,
  updateLoadMoreCounter: PropTypes.func,
  updatedSearchData: PropTypes.array,
  updatefrom: PropTypes.func,
}